import Select from '~/components/Select';
import DateInput from '~/components/DateInput';
import QuestionLabel from '~/components/forms/questions/QuestionLabel';
import { FormPart, part } from '~/lib/FormCssApi';
import { useEffect, useState } from 'react';

const SendOnInput = ({ value, onChange, className }) => {
    const [selectedSend, setSelectedSend] = useState('');

    function updateSelectedBasedOnDate(value) {
        if (!value) {
            setSelectedSend('');
        } else if (new Date(value) < new Date()) {
            setSelectedSend('now');
        } else {
            setSelectedSend('scheduled');
        }
    }

    useEffect(() => {
        updateSelectedBasedOnDate(value);
    }, [value]);

    return (
        <div {...part(FormPart.CONTROL)} className={className}>
            <QuestionLabel label="Send On" />
            <Select
                {...part(FormPart.INPUT)}
                onChange={value => {
                    setSelectedSend(value);
                    if (!value) {
                        onChange(null);
                    } else if (value === 'now') {
                        onChange(new Date());
                    }
                }}
                value={selectedSend}
                options={{
                    '': "I'll deliver this on my own to the recipient",
                    now: 'Send immediately',
                    scheduled: 'Send on...',
                }}
            />
            {selectedSend === 'scheduled' && (
                <DateInput
                    {...part(FormPart.INPUT)}
                    value={value}
                    onChange={value => {
                        onChange(value);
                        updateSelectedBasedOnDate(value);
                    }}
                    className="mt-2"
                />
            )}
        </div>
    );
};

export default SendOnInput;
